const customPhotoInput = document.getElementById("custom_photo");
const customPhotobtn = document.querySelectorAll(".upload-label")[1];
const submitButton = document.querySelector('button[type="submit"]');

// Helper function for Shopify-style rounding (round unit price first, then multiply)
function calculateDiscountedPrice(regularPrice, quantity, discountPercent) {
  if (isNaN(regularPrice) || regularPrice <= 0) return 0;
  if (isNaN(quantity) || quantity <= 0) return 0;
  if (isNaN(discountPercent)) discountPercent = 0;
  
  // Step 1: Calculate discounted unit price
  let unitPrice = regularPrice * (100 - discountPercent) / 100;
  
  // Step 2: Round unit price to 2 decimals (Shopify style)
  unitPrice = Math.ceil(unitPrice * 100) / 100;
  
  // Step 3: Multiply by quantity
  let totalPrice = quantity * unitPrice;
  
  // Step 4: Round final total to 2 decimals
  return Math.round(totalPrice * 100) / 100;
}

setTimeout(() => {
  document.querySelectorAll('input[name="quantity"]').forEach((radio) => {
    radio.addEventListener("change", function () {
      // Remove background color from all .quantity-options
      document.querySelectorAll(".quantity-options").forEach((option) => {
        option.style.background = "none";
      });

      // Add background color to the selected .quantity-options
      if (this.checked) {
        this.closest(".quantity-options").style.background = "#ececec";
      }
    });

    // Check if this radio button is already checked and apply background color
    if (radio.checked) {
      radio.closest(".quantity-options").style.background = "#ececec";
    }
  });
}, 2000);

setTimeout(() => {
  document
    .querySelector(".size-dropdown")
    .addEventListener("click", function () {
      const sizeOptions = document.getElementById("size-options");
      sizeOptions.style.display =
        sizeOptions.style.display === "block" ? "none" : "block";
    });

  // Handle radio button selection and update dropdown

  document
    .querySelectorAll('input[name="dimensions"]')
    .forEach(function (radio) {
      function handleEvent() {
        const selectedValue = this.closest("label").textContent.trim();
        document.querySelector(".size-dropdown").textContent = selectedValue;
        document.getElementById("size-options").style.display = "none";
      }

      // Apply both 'change' and 'click' event listeners
      radio.addEventListener("change", handleEvent);
      radio.addEventListener("click", handleEvent);
    });

  const firstSelectedValue = document
    .querySelector('input[name="dimensions"]:checked')
    .closest("label")
    .textContent.trim();
  document.querySelector(".size-dropdown").textContent = firstSelectedValue;
}, 3000);

function getVariantFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get("variant");
  if (variant) {
    return parseInt(variant);
  } else {
    var firstvarient = document
      .querySelector("[var-id]")
      .getAttribute("var-id");
    document.querySelector("#size-options label").click();
    document.querySelectorAll('input[name="quantity"]')[4].click();
    document.querySelector(".size-dropdown").innerText = document.querySelector(
      "#size-options label"
    ).innerText;
    return parseInt(firstvarient);
  }
}

function getCurrentPrice() {
  const variantId = getVariantFromURL();
  if (!variantId) return 0;

  const elements = document.querySelectorAll('input[name="id"]');
  elements.forEach((element) => {
    element.value = variantId;
  });

  // Find the div element with the matching variant ID
  const priceElement = document.querySelector(
    `div[var-id="${variantId}"] span`
  );
  if (!priceElement) return 0;

  // Extract the price from the innerText of the element
  const priceText = priceElement.innerText.trim();
  const regex = /\d+,\d+/g; // Matches prices with commas as decimals
  const matches = priceText.match(regex);

  // If a match is found, replace the comma with a dot for correct parsing
  const priceWithDot = matches ? matches[0].replace(",", ".") : "0";

  return parseFloat(priceWithDot);
}

function populateOptions() {
  const sizeOptions = document.getElementById("size-options");
  const quantityOptions = document.getElementById("quantity-options");

  if (sizeOptions && quantityOptions) {
    data.sizes.forEach((size) => {
      const label = document.createElement("label");
      label.classList.add("size_options");
      label.classList.add("form__label");
      label.innerHTML = `<input type="radio" name="dimensions" value="${size.value}" onchange="toggleCustomSizeInput(this)" data-total="${size.total}" /> ${size.label}`;
      sizeOptions.appendChild(label);
    });

    data.quantities.forEach((quantity, index) => {
      var dynamic_save;
      if (quantity.discount != 0) {
        dynamic_save = `-${quantity.discount}%`;
      } else {
        dynamic_save = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
      }

      const pcsText = quantity.value !== "custom" ? " pcs" : ""; // Conditional check for "pcs"

      const div = document.createElement("div");
      div.innerHTML = `<label class="quantity-options form__label">
                        <div class="quantity-data">
                            <input class="radio-inp" type="radio" name="quantity" value="${quantity.value}" onchange="toggleCustomQuantityInput(this)" data-discount="${quantity.discount}" /> &nbsp; ${quantity.label}${pcsText}</div>
                        <div class="dynamic_price" data-quantity="${quantity.value}" data-save="${quantity.discount}"></div>
                        <div class="dynamic_sav dynamic_save_${index}" data-save="${quantity.value}">${dynamic_save}</div>
                    </label>`;
      quantityOptions.appendChild(div);
    });

    // Automatically select size and quantity based on URL or localStorage
    const selectedVariantValue = getVariantFromURL();
    const selectedSizeValue = getSizeFromURL() || getSizeFromLocalStorage();
    const selectedQuantityValue =
      getQuantityFromURL() || getQuantityFromLocalStorage();

    if (selectedVariantValue) {
      selectSizeBasedOnVariant(selectedVariantValue);
    }
    if (selectedSizeValue) {
      selectSizeBasedOnValue(selectedSizeValue);
    }
    if (selectedQuantityValue) {
      selectQuantityBasedOnValue(selectedQuantityValue);
    }
  } else {
    console.error("Size options or quantity options element not found.");
  }
}

function getSizeFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const size = urlParams.get("size");
  return size ? size : null;
}

function getQuantityFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const quantity = urlParams.get("quantity");
  return quantity ? quantity : null;
}

function getSizeFromLocalStorage() {
  return localStorage.getItem("selectedSize");
}

function getQuantityFromLocalStorage() {
  return localStorage.getItem("selectedQuantity");
}

function saveSizeToLocalStorage(size) {
  localStorage.setItem("selectedSize", size);
}

function saveQuantityToLocalStorage(quantity) {
  localStorage.setItem("selectedQuantity", quantity);
}

function selectSizeBasedOnVariant(variantValue) {
  const sizeRadios = document.querySelectorAll(
    '#size-options input[type="radio"]'
  );
  sizeRadios.forEach((radio) => {
    if (parseInt(radio.getAttribute("data-total")) === variantValue) {
      radio.checked = true;
      toggleCustomSizeInput(radio);
    }
  });
}

function selectSizeBasedOnValue(sizeValue) {
  const sizeRadios = document.querySelectorAll(
    '#size-options input[type="radio"]'
  );
  sizeRadios.forEach((radio) => {
    if (radio.value === sizeValue) {
      radio.checked = true;
      toggleCustomSizeInput(radio);
    }
  });
}

function selectQuantityBasedOnValue(quantityValue) {
  const quantityRadios = document.querySelectorAll(
    '#quantity-options input[type="radio"]'
  );
  quantityRadios.forEach((radio) => {
    if (radio.value == quantityValue) {
      radio.checked = true;
      toggleCustomQuantityInput(radio);
    }
  });
}

const checkbox = document.getElementById("enable_lamination");

function uncheckCheckbox() {
  checkbox.checked = false;
  checkbox.dispatchEvent(new Event("change")); // Trigger change event
  checkbox.setAttribute("name", "properties[Pelliculage]");
}
uncheckCheckbox();

checkbox.addEventListener("change", function () {
  var updatedP = getSizeFromLocalStorage();
  checkbox.setAttribute("name", "properties[Pelliculage]");
  // console.log(updatedP);
  if (this.checked) {
    variantHandler(updatedP);
    document.querySelector("#final-lami").innerHTML = "Oui";
    checkbox.value = "Oui"; // Set value to "Oui" when checked
  } else {
    variantHandler(updatedP);
    document.querySelector("#final-lami").innerHTML = "Non";
    checkbox.value = "Non"; // Set value to "Non" when unchecked
  }
});

function updatePrice(selectedQuantity) {
  let price = 0;
  let discount = 0;

  if (!isNaN(selectedQuantity)) {
    let basePrice = getCurrentPrice();

    const selectedQuantityObj = data.quantities.reduce((prev, curr) => {
      return selectedQuantity >= curr.value ? curr : prev;
    });

    if (selectedQuantityObj) {
      discount = selectedQuantityObj.discount || 0;
    }

    // Use Shopify-style rounding
    price = calculateDiscountedPrice(basePrice, selectedQuantity, discount);

    document.querySelector("#total-big").innerHTML = `€${price.toFixed(2)}`;
  } else {
    document.querySelector("#total-big").innerHTML = "Invalid quantity";
  }
  const quantityElement = document.querySelector(".quantity__input");
  if (quantityElement) {
    quantityElement.value = selectedQuantity;
    quantityElement.setAttribute("value", selectedQuantity);
  }
  saveQuantityToLocalStorage(selectedQuantity);
}

function variantHandler(sizeValue) {
  let variantInputs = document.querySelectorAll(
    ".product-form__input--pill input"
  );

  if (document.querySelector("#enable_lamination").checked) {
  } else {
    variantInputs = Array.from(variantInputs).filter((input) => {
      return /^\d+$/.test(input.value);
    });
  }

  if (!variantInputs) {
    return;
  }
  let closestSize = null;
  variantInputs.forEach((values) => {
    let dataValue = parseInt(values.value, 10);
    if (
      closestSize === null ||
      (dataValue >= sizeValue &&
        (closestSize < sizeValue || dataValue < closestSize))
    ) {
      closestSize = dataValue;
    }
  });

  variantInputs.forEach((values) => {
    let dataValue = parseInt(values.value, 10);
    if (dataValue === closestSize) {
      values.checked = true;
      const radioBtn = document.getElementById(values.id);
      if (radioBtn) {
        radioBtn.checked = true;
        const changeEvent = new Event("change", {
          bubbles: true,
          cancelable: true,
        });
        radioBtn.dispatchEvent(changeEvent);
        radioBtn.click();

        setTimeout(() => {
          const updated_price = getCurrentPrice();
          
          document
            .querySelectorAll("#quantity-options .dynamic_price")
            .forEach((d) => {
              var prices;
              const previousSibling = d.previousElementSibling;
              const discount = parseFloat(d.getAttribute("data-save"));
              const quantity = parseFloat(d.getAttribute("data-quantity"));
              
              if (isNaN(quantity)) return;

              // Shopify-style rounding: round unit price first, then multiply
              let discountedPricePerUnit = (updated_price * (100 - discount)) / 100;
              discountedPricePerUnit = Math.ceil(discountedPricePerUnit * 100) / 100;
              let total_price = quantity * discountedPricePerUnit;
              total_price = Math.round(total_price * 100) / 100;

              if (discount != 0 && !isNaN(discount)) {
                if (
                  previousSibling &&
                  previousSibling.classList.contains("quantity-data")
                ) {
                  const radioButton = previousSibling.querySelector(
                    'input[type="radio"]:checked'
                  );
                  if (radioButton) {
                    document.querySelector("#total-big").innerHTML = `€${total_price.toFixed(2)}`;
                  }
                  previousSibling
                    .querySelector('input[type="radio"]')
                    .setAttribute(
                      "data-final-price",
                      `€${total_price.toFixed(2)}`
                    );
                }

                prices = `<span class="discounted_price">€${total_price.toFixed(2)}</span>`;
              } else {
                if (
                  previousSibling &&
                  previousSibling.classList.contains("quantity-data")
                ) {
                  const radioButton = previousSibling.querySelector(
                    'input[type="radio"]:checked'
                  );
                  if (radioButton) {
                    document.querySelector("#total-big").innerHTML = `€${total_price.toFixed(2)}`;
                  }
                  previousSibling
                    .querySelector('input[type="radio"]')
                    .setAttribute(
                      "data-final-price",
                      `€${total_price.toFixed(2)}`
                    );
                }

                prices = `<span class="">€${total_price.toFixed(2)}</span><span class="discounted_price">&nbsp;</span>`;
              }
              d.innerHTML = `<div class="prices">${prices}</div>`;
            });
        }, 100);
      } else {
        console.error("Radio button element not found for id:", values.id);
      }
    }
  });
}

function toggleCustomSizeInput(radio) {
  const customSizeInput = document.getElementById("custom-price-input");
  if (customSizeInput) {
    if (radio.value === "custom") {
      customSizeInput.style.display = "flex";
      var val1 = document.querySelector("#Custom_size1").value;
      var val2 = document.querySelector("#Custom_size2").value;
      radio.setAttribute("data-total", val1 * val2);
    } else {
      customSizeInput.style.display = "none";
    }
  } else {
    console.error("Custom size input element not found.");
  }

  const sizeValue = radio.getAttribute("data-total");
  variantHandler(sizeValue);
  saveSizeToLocalStorage(sizeValue);

  document.querySelector("#final-size").innerHTML = `${radio.value} cm`;
  document.querySelector("#final-size-input").value = `${radio.value} cm`;
}

const input1 = document.getElementById("Custom_size1");
const input2 = document.getElementById("Custom_size2");

function validateAndMultiply() {
  if (!input1 || !input2) {
    console.error("Custom size input elements not found.");
    return;
  }

  let value1 = parseFloat(input1.value);
  let value2 = parseFloat(input2.value);
  let err_size = document.getElementById("err_size");
  if (isNaN(value1) || isNaN(value2)) {
    err_size.innerHTML = "Enter height & width";
    return;
  } else {
    err_size.innerHTML = "";
  }
  if (value1 < 2 || value1 > 60 || value2 < 2 || value2 > 60) {
    err_size.innerHTML = "La taille doit être comprise entre 2 et 60";
    return;
  } else {
    err_size.innerHTML = "";
  }
  let result = value1 * value2;
  document.querySelector("#final-size").innerHTML = `${value1}x${value2} cm`;
  document.querySelector("#final-size-input").value = `${value1}x${value2} cm`;
  variantHandler(result);
  saveSizeToLocalStorage(result);

  setTimeout(() => {
    const updated_price = getCurrentPrice();
    document
      .querySelectorAll("#quantity-options .dynamic_price")
      .forEach((d) => {
        var prices;
        const previousSibling = d.previousElementSibling;
        const discount = parseFloat(d.getAttribute("data-save"));
        const quantity = parseFloat(d.getAttribute("data-quantity"));
        
        if (isNaN(quantity)) return;

        // Shopify-style rounding: round unit price first, then multiply
        let discountedPricePerUnit = (updated_price * (100 - discount)) / 100;
        discountedPricePerUnit = Math.ceil(discountedPricePerUnit * 100) / 100;
        let total_price = quantity * discountedPricePerUnit;
        total_price = Math.round(total_price * 100) / 100;

        if (discount != 0 && !isNaN(discount)) {
          if (
            previousSibling &&
            previousSibling.classList.contains("quantity-data")
          ) {
            const radioButton = previousSibling.querySelector(
              'input[type="radio"]:checked'
            );
            if (radioButton) {
              document.querySelector("#total-big").innerHTML = `€${total_price.toFixed(2)}`;
            }
            previousSibling
              .querySelector('input[type="radio"]')
              .setAttribute(
                "data-final-price",
                `€${total_price.toFixed(2)}`
              );
          }

          prices = `<span class="discounted_price">€${total_price.toFixed(2)}</span>`;
        } else {
          if (
            previousSibling &&
            previousSibling.classList.contains("quantity-data")
          ) {
            const radioButton = previousSibling.querySelector(
              'input[type="radio"]:checked'
            );
            if (radioButton) {
              document.querySelector("#total-big").innerHTML = `€${total_price.toFixed(2)}`;
            }
            previousSibling
              .querySelector('input[type="radio"]')
              .setAttribute(
                "data-final-price",
                `€${total_price.toFixed(2)}`
              );
          }

          prices = `<span class="">€${total_price.toFixed(2)}</span><span class="discounted_price">&nbsp;</span>`;
        }
        d.innerHTML = `<div class="prices">${prices}</div>`;
      });
  }, 100);
}

if (input1 && input2) {
  input1.addEventListener("input", validateAndMultiply);
  input2.addEventListener("input", validateAndMultiply);
}

function toggleCustomQuantityInput(radio) {
  let customQuantityInput = document.getElementById("custom-quantity-input");
  let customQuantityText = document.getElementById("custom-quantity-text");
  let quantityInput = document.querySelector(".quantity__input");
  let finalDays = document.getElementById("final-days");

  if (customQuantityInput && quantityInput && finalDays) {
    if (radio.value === "custom") {
      customQuantityInput.style.display = "block";
      customQuantityText.style.display = "block";

      updatePrice(100);
      saveQuantityToLocalStorage(100);
      document.querySelector("#final-qty").innerHTML = 100;
      updateDays(100);
      customQuantityInput.value = 100;
      radio.value = 100;
      const submitButton = document.querySelector(".product-form__submit");

      // Remove existing listener to avoid duplicates
      const newInput = customQuantityInput.cloneNode(true);
      customQuantityInput.parentNode.replaceChild(newInput, customQuantityInput);
      customQuantityInput = newInput;

      customQuantityInput.addEventListener("input", function () {
        let quantity = parseInt(customQuantityInput.value);
        radio.value = quantity;
        let errorMessage = document.querySelector(".custom-error-msg");

        if (!errorMessage) {
          errorMessage = document.createElement("div");
          errorMessage.classList.add("custom-error-msg");
          errorMessage.style.color = "red";
          document.querySelector("#custom-quantity-text").before(errorMessage);
        }

        if (quantity < 10 || isNaN(quantity)) {
          errorMessage.innerHTML = "la quantité doit être supérieure à 10";
          errorMessage.style.display = "block";
          submitButton.disabled = true;
        } else {
          errorMessage.innerHTML = "";
          errorMessage.style.display = "none";
          saveQuantityToLocalStorage(100);
          document.querySelector("#final-qty").innerHTML = quantity;
          updatePrice(quantity);
          updateDays(quantity);
          submitButton.disabled = false;
        }
      });

      updatePrice(100);
    } else {
      const radioInputs = document.querySelectorAll(".radio-inp");
      const lastRadioInput = radioInputs[radioInputs.length - 1];
      if (lastRadioInput) lastRadioInput.value = "custom";

      customQuantityInput.style.display = "none";
      customQuantityText.style.display = "none";
      updatePrice(radio.value);
      saveQuantityToLocalStorage(radio.value);
      document.querySelector("#final-qty").innerHTML = radio.value;
      
      // Get the final price from the selected radio's data-final-price attribute
      const finalPrice = radio.getAttribute("data-final-price");
      if (finalPrice) {
        document.querySelector("#total-big").innerHTML = finalPrice;
      }
      updateDays(radio.value);
    }
  } else {
    console.error(
      "Custom quantity input, quantity input element, or final days element not found."
    );
  }

  function updateDays(quantity) {
    let days;
    const qtyNum = parseFloat(quantity);
    if (isNaN(qtyNum)) {
      days = 4;
    } else if (qtyNum < 200) {
      days = 4;
    } else if (qtyNum < 499) {
      days = 5;
    } else if (qtyNum < 999) {
      days = 6;
    } else {
      days = 7;
    }
    finalDays.innerHTML = days + " Jours";
  }
}

document.addEventListener("DOMContentLoaded", populateOptions);

document.addEventListener("DOMContentLoaded", function () {
  var previewContainer = document.querySelector(".image-preview-container");
  var previewImage = document.getElementById("image_preview");

  document
    .getElementById("custom_photo")
    .addEventListener("change", function (event) {
      const file = event.target.files[0];
      const previewImage = document.getElementById("image_preview");

      if (file) {
        const fileType = file.type;

        if (fileType.startsWith("image/")) {
          const reader = new FileReader();
          reader.onload = function (e) {
            previewImage.src = e.target.result;
            previewImage.style.display = "block";
          };
          reader.readAsDataURL(file);
        } else if (fileType === "application/pdf") {
          previewImage.src =
            "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/80942.png?v=1725791225";
          previewImage.style.display = "block";
        } else {
          previewImage.src =
            "https://cdn.shopify.com/s/files/1/0578/4882/3996/files/page-file-icon.webp?v=1725791274";
          previewImage.style.display = "block";
        }
      }
    });

  if (previewContainer && previewImage) {
    previewContainer.addEventListener("mouseenter", function () {
      previewImage.style.transform = "scale(1.05)";
    });

    previewContainer.addEventListener("mouseleave", function () {
      previewImage.style.transform = "scale(1)";
    });
  }
});